import type { ReactElement } from 'react';
import React from 'react';
import clsx from 'clsx';
import type { BadgeProps as BootstrapBadgeProps } from 'reactstrap';
import { Badge as BootstrapBadge } from 'reactstrap';

export { BadgeProps } from 'reactstrap';

const getTextColor = (color: string | undefined): string | undefined => {
  switch (color) {
    case 'primary':
    case 'secondary':
    case 'success':
    case 'danger':
    case 'dark':
      return 'text-light';
    case 'warning':
    case 'info':
    case 'light':
      return 'text-dark';
    default:
      return undefined;
  }
};

/**
 * A badge is a small component for identifying an important piece of information that often acts as a tag or label.
 * We have a wrapper around the standard `reactstrap` `badge` so that it is easier to restyle it if desired.
 *
 * - a wrapper around reactstrap badge
 * - provide bootstrap styled badge
 */
export default function Badge({ children, ...props }: BootstrapBadgeProps): ReactElement {
  return (
    <BootstrapBadge {...props} className={clsx(props.className, getTextColor(props.color))}>
      {children}
    </BootstrapBadge>
  );
}
